export default __webpack_public_path__ + "static/media/noitem.401794a8.png";